import React from 'react'
import Setting from '../../components/admin/Settings'

export default class Settings extends React.Component{
  render() {
    return (
      <Setting/>
    )
  }
}